// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Like ${i.handle} on Facebook`
};

const de_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Gefällt mir ${i.handle} auf Facebook`
};

const es_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Me gusta a ${i.handle} en Facebook`
};

const fr_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Aimer ${i.handle} sur Facebook`
};

const fi_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Tykkää ${i.handle} Facebookissa`
};

const ja_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Facebookで${i.handle}にいいね`
};

const nl_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Like ${i.handle} op Facebook`
};

const pt_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Gostar de ${i.handle} no Facebook`
};

const ro_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Apreciază ${i.handle} pe Facebook`
};

const th_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `กดไลค์ ${i.handle} บน Facebook`
};

const ur_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.handle} کو فیس بک پر لائک کریں`
};

const zh_hant1_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `在 Facebook 上按讚 ${i.handle}`
};

const da_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Synes godt om ${i.handle} på Facebook`
};

const it_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Metti mi piace a ${i.handle} su Facebook`
};

const vn_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Thích ${i.handle} trên Facebook`
};

const ko_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Facebook에서 ${i.handle} 좋아요 누르기`
};

const tr_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Facebook'ta ${i.handle} sayfasını beğen`
};

const lv_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Patīk ${i.handle} Facebook`
};

const ar_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `أعجب بـ ${i.handle} على فيسبوك`
};

const bs_widget_actions_like_on_facebook = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Lajkujte ${i.handle} na Facebooku`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ handle: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_actions_like_on_facebook = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_actions_like_on_facebook(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_actions_like_on_facebook", locale)
	if (locale === "en") return en_widget_actions_like_on_facebook(inputs)
	if (locale === "de") return de_widget_actions_like_on_facebook(inputs)
	if (locale === "es") return es_widget_actions_like_on_facebook(inputs)
	if (locale === "fr") return fr_widget_actions_like_on_facebook(inputs)
	if (locale === "fi") return fi_widget_actions_like_on_facebook(inputs)
	if (locale === "ja") return ja_widget_actions_like_on_facebook(inputs)
	if (locale === "nl") return nl_widget_actions_like_on_facebook(inputs)
	if (locale === "pt") return pt_widget_actions_like_on_facebook(inputs)
	if (locale === "ro") return ro_widget_actions_like_on_facebook(inputs)
	if (locale === "th") return th_widget_actions_like_on_facebook(inputs)
	if (locale === "ur") return ur_widget_actions_like_on_facebook(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_actions_like_on_facebook(inputs)
	if (locale === "da") return da_widget_actions_like_on_facebook(inputs)
	if (locale === "it") return it_widget_actions_like_on_facebook(inputs)
	if (locale === "vn") return vn_widget_actions_like_on_facebook(inputs)
	if (locale === "ko") return ko_widget_actions_like_on_facebook(inputs)
	if (locale === "tr") return tr_widget_actions_like_on_facebook(inputs)
	if (locale === "lv") return lv_widget_actions_like_on_facebook(inputs)
	if (locale === "ar") return ar_widget_actions_like_on_facebook(inputs)
	if (locale === "bs") return bs_widget_actions_like_on_facebook(inputs)
	return "widget_actions_like_on_facebook"
};